import React from 'react';
import { QuestionContainer, TitleField, AnswerField, Text } from './styles';

interface Props {
  openQuestion: any;
}

const OpenStyleQuestionSummary: React.FC<Props> = ({ openQuestion }) => {
  const getQuestionText = (): string => {
    const { questionIdComplete, question } = openQuestion;

    if (!questionIdComplete.includes('.')) {
      return question.text;
    }

    const alternativeId = Number(questionIdComplete.split('.')[1]);
    const alternative = question.alternatives.find(
      (item: any) => item.value === alternativeId,
    );

    return alternative?.text;
  };

  return (
    <QuestionContainer>
      <TitleField>
        <Text>
          {openQuestion.customQuestionText !== ''
            ? openQuestion.customQuestionText
            : getQuestionText()}
        </Text>
      </TitleField>
      <AnswerField>
        <Text>
          {openQuestion.result.value !== ''
            ? openQuestion.result.value
            : 'Keine Antwort'}
        </Text>
      </AnswerField>
    </QuestionContainer>
  );
};

export default OpenStyleQuestionSummary;
